module.exports = __webpack_public_path__ + "static/img/holiday-raspberry_th.2731808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/holiday-raspberry_th.png
// module id = LSmu
// module chunks = 0